import {
    PatientIdentifier
  } from 'one-state-patientidentifiers/src/patientidentifier';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Patient Identifier Component
 * @param response has the backend
 * pcp response
 * @param context has settings etc..
 */



export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */

    
    let result :any = {
        identifiers:[],
        error:undefined
    }
    const { log } = context;

    if (response && (response.status >= 400 || response.type == "error")) {
        result.error=response;
     }

    if (response && response.length > 0) {
        const rs = response;
        let identifierarray:PatientIdentifier[] = [];
        rs.forEach((ele: any) => {
            let identifierobj : PatientIdentifier ={
                id :"",
                headertypeid:""
            }
            if(ele?.Identifiers && ele?.Identifiers.length > 0) {
                ele.Identifiers.forEach((identifierdata:any)=> {
                    if(identifierdata?.IDType === "FHIR STU3") {
                        identifierobj.id = identifierdata?.ID ? identifierdata.ID : "";
                    }
                    else if(identifierdata?.IDType === "WPRINTERNAL") {
                        identifierobj.headertypeid = identifierdata?.ID ? identifierdata.ID : "";
                    }
                })
            }
            if(identifierobj.id.length > 0 && identifierobj.headertypeid.length > 0) {
                identifierarray.push(identifierobj);
            }
        });
        result.identifiers=identifierarray;
    }
    log.debug(
        "ccw-gadget,patientidentifiers-epic",
        "patientidentifiers-epic transforamtion response ", {
        result
    });

    return result;
}